import type { Editor as CoreEditor } from '@tiptap/core';

export const isText = (editor: CoreEditor): boolean => {
	const isText = editor.state.selection.$head.parent.lastChild?.isText;
	return isText ?? false;
};
export const isHubs = (editor: CoreEditor): boolean => {
	const isHubs = editor.state.selection.$head.parent.lastChild?.type.name.startsWith('hubs');
	return isHubs ?? false;
};
export const isSelected = (editor: CoreEditor): boolean => {
	return editor.state.selection.content().size > 0;
};
